<app-video-player [autoPlay]="true" (cancelClick)="onCancelClicked()" [content]="dialogData.video"></app-video-player>
